import React, { FC } from "react";
import { LabelTitle } from "./styled";

export const RestorationTab: FC<{ title: string; isActive: boolean }> = ({
  title,
  isActive,
}) => {
  return <LabelTitle isActive={isActive}>{title}</LabelTitle>;
};
